import { CopyAll } from '@mui/icons-material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useGlobalToast } from '@providers/globalToastProvider';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useTranslation } from 'react-i18next';

export type CopyIdProps = {
  id: string;
  /** Truncate long ids with ellipsis; use in constrained layouts (e.g. dialog headers). */
  truncate?: boolean;
};

export const CopyId = ({ id, truncate = false }: CopyIdProps) => {
  const { t } = useTranslation('shared');
  const { sys } = useThemeTokens();
  const { showToast } = useGlobalToast();

  return (
    <Box
      sx={{
        background: sys.color.background,
        padding: '0px 16px',
        height: '32px',
        borderRadius: sys.borderRadius.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ...(truncate && { maxWidth: '100%', minWidth: 0 }),
        '&:hover': {
          background: sys.color.neutralPressed,
        },
      }}
      onClick={() => {
        navigator.clipboard.writeText(id);
        showToast({ severity: 'success', message: t('copiedToClipboard') });
      }}
    >
      <Typography
        variant='labelLarge'
        sx={
          truncate
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
                flex: 1,
              }
            : undefined
        }
      >
        {id}
      </Typography>
      <CopyAll sx={{ fontSize: '16px', ml: 1, flexShrink: 0 }} />
    </Box>
  );
};
